export default {
      id: "Icon--directionDown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--directionDown",
      toString: function () {
        return this.url;
      }
    }